module.exports = __webpack_public_path__ + "static/media/xu_xue_lie_ren.cacecb49.png";